module.exports = __webpack_public_path__ + "media/Dotkit2.5e029357.mp4";